<script setup lang="ts">
import { ref } from 'vue'

import { useAtcWatchlist } from '../../composables/useAtcWatchlist'
import { useDefinitionsRbac } from '../../composables/useDefinitionsRbac'
import { useMetaWatchlist } from '../../composables/useMetaWatchlist'

import CreativeWatchlistModal from './CreativeWatchlistModal.vue'

import { useI18n } from '@/shared/i18n'
import { Button, Icon } from '@/shared/ui'

const { t } = useI18n()
const rbac = useDefinitionsRbac()
const meta = useMetaWatchlist()
const atc = useAtcWatchlist()
const open = ref(false)
</script>

<template>
  <Button
    v-if="rbac.canEdit.value"
    class="watchlist-create"
    variant="soft"
    data-testid="watchlist-create"
    @click="open = true"
  >
    <Icon name="plus" weight="regular" :size="14" />
    {{ t('workspaceDefinitions.watchlist.create') }}
  </Button>
  <CreativeWatchlistModal v-model="open" :meta="meta" :atc="atc" />
</template>
